const PhaseOperations = Object.freeze({
	UPDATE: "UPDATE",
	DELETE: "DELETE",
	ADD: "ADD",
	EXPORT: "EXPORT",
	LOCK: "LOCK",
	UNLOCK: "UNLOCK",
	ARCHIVE: "ARCHIVE",
	UNARCHIVE: "UNARCHIVE",
	REORDER: "REORDER",
});

module.exports = PhaseOperations;
